import {useCallback} from 'react';
import assert from 'assert-ts';
import type {ReviewStatusType} from 'types';
import type {UseValueById} from 'schema/form/types';
import type {RootState} from 'store/types';
import {useAppSelector} from 'store/hooks';

const getValue = (
  state: RootState,
  rootPath: string | undefined,
  changeRequestId: string,
): ReviewStatusType => {
  if (rootPath === undefined) {
    assert(false, 'useChangeRequestStatus: localPath is undefined');
    return 'none';
  }

  return (
    state.metadataEdit.approvedChanges[changeRequestId]?.rootPaths ?? []
  ).includes(rootPath)
    ? 'approved'
    : 'none';
};

const useValueSelector = (
  localPath: string | undefined,
  changeRequestId: string,
) =>
  useCallback(
    (state: RootState): ReviewStatusType =>
      getValue(state, localPath, changeRequestId),
    [changeRequestId, localPath],
  );

export const useChangeRequestStatus: UseValueById<ReviewStatusType> = (
  /**
   * Change request root path, including 'work.', 'expression.', or 'manifestation.'
   */
  rootPath: string | undefined,
  changeRequestId: string,
): ReviewStatusType => {
  const selector = useValueSelector(rootPath, changeRequestId);
  const value = useAppSelector(selector);

  return value;
};
